module.exports = {
	"classes": [
		"customers-page"
	],
	"title": "Customers",
	"metas": {
		"description": "Auth0 is used by many companies and apps to manage their authentication. Learn who are they and how they use Auth0 as an Identity Platform."
	},
	"opengraph": {
		"og:title": "Customers",
		"og:description": "Auth0 is used by many companies and apps to manage their authentication. Learn who are they and how they use Auth0 as an Identity Platform.",
		"og:url": "https://auth0.com/customers",
		"og:image": "http://cdn2.auth0.com/blog/customers-twittercard-2x.png",
		"og:image:secure_url": "https://cdn2.auth0.com/blog/customers-twittercard-2x.png"
	},
	"twittercard": {
		"twitter:title": "Customers",
		"twitter:description": "Auth0 is used by many companies and apps to manage their authentication. Learn who are they and how they use Auth0 as an Identity Platform",
		"twitter:image": [
			{
				"src": "https://cdn2.auth0.com/blog/customers-twittercard-2x.png"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/customers/metadata.json
// module id = 1114
// module chunks = 0